import {gql} from "@apollo/client";

export const ADD_REFEREE_TO_STAGE_MUTATION = gql`
mutation AddRefereeToStage($stageId: Int!, $refereeId: Int!, $action: String) {
    addRefereeToStage(stageId: $stageId, refereeId: $refereeId, action: $action) {
        success
    }
}
`;